// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { LoginAuthLoginEmailPostMutationRequest, LoginAuthLoginEmailPostMutationResponse, LoginAuthLoginEmailPost401, LoginAuthLoginEmailPost422, LoginAuthLoginEmailPost423 } from "../models/emailAuthController/LoginAuthLoginEmailPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getLoginAuthLoginEmailPostUrl() {
  const res = { method: 'POST', url: `/auth/login/email` as const }
  return res
}

/**
 * @description Login with email or username and password.
 * Sets session cookie on success.
 * @summary Login
 * {@link /auth/login/email}
 */
export async function loginAuthLoginEmailPost(data: LoginAuthLoginEmailPostMutationRequest, config: Partial<RequestConfig<LoginAuthLoginEmailPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LoginAuthLoginEmailPostMutationResponse, ResponseErrorConfig<LoginAuthLoginEmailPost401 | LoginAuthLoginEmailPost422 | LoginAuthLoginEmailPost423>, LoginAuthLoginEmailPostMutationRequest>({ method : "POST", url : getLoginAuthLoginEmailPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}